import {
  CreateAdditionalFileAuthorizationRequest,
  CreateAuthorizationRequest,
  GetAuthorizationResult,
  GetGrantableResult,
  LoginAdminResult,
  OreSiUser,
} from "@/types/generated/UsedGeneratedTypes";
import { Fetcher } from "../Fetcher";

// Types simples (à ajuster si tu connais la structure précise)
type Params = Record<string, any>;

export class AuthorizationService extends Fetcher {
  static INSTANCE = new AuthorizationService();

  constructor() {
    super();
  }

  async getAdminAuthorizationsForOpenAdom(
    applicationName?: string,
    authorizationId?: string,
  ): Promise<GetAuthorizationResult | LoginAdminResult> {
    return applicationName
      ? this.get(`applications/${applicationName}/authorization/${authorizationId}`)
      : this.get("authorizationForAdmin");
  }

  async getDataAuthorizations(applicationName: string): Promise<GetAuthorizationResult> {
    return this.get(`applications/${applicationName}/authorization`);
  }

  async getadditionalFilesAuthorizations(applicationName: string, params: Params): Promise<any> {
    return this.get(`applications/${applicationName}/additionalfiles/authorization`, params);
  }

  async revokeAdditionalFileAuthorization(applicationName: string, id: string): Promise<any> {
    return this.delete(`applications/${applicationName}/additionalFiles/authorization/${id}`);
  }

  async getAuthorizationGrantableInfos(applicationName: string): Promise<GetGrantableResult> {
    return this.get(`applications/${applicationName}/grantable`);
  }

  async createorUpdateAuthorization(
    applicationName: string,
    authorizationRequest: CreateAuthorizationRequest,
  ): Promise<Map<string, string>> {
    if (authorizationRequest.uuid) {
      return this.put(`applications/${applicationName}/authorization`, authorizationRequest, false);
    }
    return this.post(`applications/${applicationName}/authorization`, authorizationRequest, false);
  }

  async createAuthorization(
    applicationName: string,
    authorizationRequest: CreateAuthorizationRequest,
  ): Promise<Map<string, string>> {
    return this.post(`applications/${applicationName}/authorization`, authorizationRequest, false);
  }

  async updateAuthorization(
    applicationName: string,
    authorizationRequest: CreateAuthorizationRequest,
  ): Promise<Map<string, string>> {
    return this.put(`applications/${applicationName}/authorization`, authorizationRequest, false);
  }

  async createOrUpdateAdditionalFilesAuthorization(authorization: CreateAdditionalFileAuthorizationRequest): Promise<Map<string, string>> {
    return this.post(
      `applications/${authorization.applicationNameOrId}/additionalFiles/authorization`,
      authorization,
      false,
    );
  }

  async createAuthorizedRole(
    roleName: string,
    userIdOrLogin: string,
    applicationPattern?: string,
    applicationNameOrId?: string,
  ): Promise<OreSiUser> {
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append("userIdOrLogin", userIdOrLogin);
    if (applicationPattern) {
      urlSearchParams.append("applicationPattern", applicationPattern);
    }
    if (applicationNameOrId) {
      urlSearchParams.append("applicationNameOrId", applicationNameOrId);
      return this.put(
        `applications/${applicationNameOrId}/applicationrole/${roleName}?${urlSearchParams.toString()}`,
      );
    }
    else {
      return this.put(`systemrole/${roleName}?${urlSearchParams.toString()}`);
    }
  }

  async revokeAuthorizedRole(
    roleName: string,
    userIdOrLogin: string,
    applicationPattern?: string,
    applicationNameOrId?: string,
  ): Promise<OreSiUser> {
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append("userIdOrLogin", userIdOrLogin);
    if (applicationPattern) {
      urlSearchParams.append("applicationPattern", applicationPattern);
    }
    if (applicationNameOrId) {
      urlSearchParams.append("applicationNameOrId", applicationNameOrId);
      return this.delete(
        `applications/${applicationNameOrId}/applicationrole/${roleName}?${urlSearchParams.toString()}`,
      );
    }
    else {
      return this.delete(`systemrole/${roleName}?${urlSearchParams.toString()}`);
    }
  }

  async revokeAuthorization(applicationName: string, authorizationId: string): Promise<string> {
    return this.delete(`applications/${applicationName}/authorization/${authorizationId}`);
  }
}
